import React from 'react';

const StoreButton = ({icon, textOne, textTwo}) => (
    <div className="row flex-row btn-custom btn-special m-4 justify-content-center align-items-center">
        <img src={icon} alt="icon"/>
        <div className="row flex-column mr-1 ml-1">
            <span className="m-0 txt-thin"> {textOne}</span>
            <span className="m-0 txt-bold txt-25px txt-white"> {textTwo}</span>
        </div>
    </div>
);

export default StoreButton


// WEBPACK FOOTER //
// ./src/components/StoreButton.jsx